<template>
    <component :is="ViewName">
    </component>
</template>
<script>
    import registerCradesView from './registerTuanganExamineDetail.vue'
    import registerMemberView from './registerTuanyuanExamineDetail.vue'
    import unregisterView from './UnRegisterHome.vue'
    import {mapState} from 'vuex'

    export default {
        name: "Home",
        data(){
            return {
                ViewName:''
            }
        },
        components: {
            registerMemberView,
            registerCradesView,
            unregisterView
        },
        computed: {
            ...mapState({
                curUser: state => state.user,
            }),
        },
        created() {
            this.$root.PF('/checkregister', null).then(response => {
                if (response.status == 200) {
                    if (response.data.retCode === 1000) {
                        if (response.data.results.isRegisterMember == 1) {
                            this.ViewName = 'registerMemberView'
                        } else if (response.data.results.isRegisterCrades == 1) {
                            this.ViewName = 'registerCradesView'
                        } else {
                            this.ViewName = 'unregisterView'
                        }
                    }
                }
            }).catch(err => {

            })
        },
    }
</script>

<style scoped>
    .anim {
        transition: all 0.5s;
    }

    table tr td {
        height: 45px;
        border-bottom: 1px solid #e0e0e0;
        border-right: 1px solid #ddd;
    }

    table tr td:nth-child(2) {
        width: 280px;
        color: #3e3e3e;
    }

    table tr td:nth-child(1), table tr td:nth-child(3) {
        background: #f3f3f3;
        width: 142px;
        color: #444444;
        font-size: 14px;
        text-align: right;
        padding-right: 22px;
    }

    .editor_table {
        width: 100%;
        height: auto;
        border: 1px solid #e0e0e0;
        border-collapse: separate;
        border-radius: 4px;
        border-right: none;
        border-bottom: none;
        margin-bottom: 34px;
        font-size: 14px;
    }

    .bd .content2 {
        float: left;
        margin-left: 20px;
        margin-top: -2px;
        color: #000;
        width: 420px
    }

    .content2 a:hover {
        background-color: #dedede;
    }

    .state_boxs {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #cdcdcd;
        line-height: 40px;
        margin-bottom: 20px
    }

    .fa-info-circle::before {
        content: "\f041";
    }

    .float_left {
        float: left;
        margin-top: 8px;
        margin-right: 10px;
        font-size: 24px;
        color: #e21515;
        text-indent: 26px;
    }

    .state_position {
        float: left;
        margin-right: 10px;
        font-size: 14px;
        color: #666;
    }

    .panel_center {
        width: 980px;
        height: auto;
        margin: 0 auto;
        overflow: hidden;
        padding-bottom: 4px;
    }

    .panel_center .left_box {
        width: 610px;
        float: left;
        height: 260px;
        background: white;
        border: 1px solid #e1e1e1;
    }

    .haveborder {
        background: white;
        box-shadow: 0 0 4px #c5c5c5;
    }

    .wrapper {
        padding: 0 20px
    }

    .wrapper-content {
        padding: 20px;
        padding-top: 0
    }

    .panel_center .left_box {
        width: 610px;
        float: left;
        height: 260px;
        background: white;
        border: 1px solid #e1e1e1;
    }

    .panel_center .right_box {
        width: 352px;
        float: right;
        height: 260px;
        background: white;
        border: 1px solid #e1e1e1;
    }

    .panel_box {
        width: 980px;
        height: 1024px;
        margin: 20px auto 0;
        overflow: hidden;

        padding: 20px;
        padding-bottom: 0
    }

    .panel_box a {
        text-decoration: none;
    }

    .panel_box .navs {
        float: left;
        width: 210px;
        height: auto;
        margin-left: 240px;
        margin-right: 0;
        margin-top: 50px;
        margin-bottom: 22px;
        cursor: pointer;
    }

    .fa-pencil-square:before {
        font-size: 36px;
    }

    .usertitle {
        width: 100%;
        height: 44px;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        border-bottom: 1px solid #dcdcdc
    }

    .usertitle .fa {
        float: left;
        font-size: 18px;
        color: #e52125;
        margin-top: 13px;
        margin-left: 15px;
    }

    .usertitle .fa-plus {
        float: left;
        font-size: 14px;
        color: #888888;
        margin-top: 15px;
        margin-left: 15px;
    }

    .usertitle .look {
        font-size: 14px;
        color: #888888;
        margin-top: 10px;
    }

    .titlestyle {
        float: left;
        height: 44px;
        float: left;
        margin-left: 6px;
        line-height: 44px;
        font-size: 16px;
        color: #d72500;
    }

    .infolist {
        width: 570px;
        height: auto;
        margin: 12px auto;
    }

    .infolist .lineinfos {
        width: 100%;
        height: 26px;
        margin: 0 auto 12px;
    }

    .lineinfos .user_label {
        background: #e4e4e4 none repeat scroll 0 0;
        border-radius: 4px;
        color: #000;
        float: left;
        height: 26px;
        line-height: 26px;
        text-align: center;
        width: 92px;
        font-size: 14px
    }

    .lineinfos .usercontent {
        float: left;
        margin-left: 20px;
        margin-top: -2px;
        color: #000;
        width: 420px;
        line-height: 28px;
    }

    .navs .each_menu {
        width: 124px;
        height: 124px;
        border-radius: 50%;
        background: #CE0000;
        transition: background 1s;
        margin: auto;
        -webkit-transition: background 1s; /* Safari */
        line-height: 142px;
        text-align: center;
    }

    .navs .nav_title {
        text-align: center;
        margin-top: 12px;
        font-size: 16px;
        font-weight: 600;
        color: #666;
        transition: color 1s;
        -webkit-transition: color 1s;
    }

    .each_menu .fa {
        color: white;
        font-weight: 600;
        font-size: 60px;
        transition: color 1s;
        -webkit-transition: color 1s;
    }

    .panel_box .navs:hover .each_menu {
        background: #e32322
    }

    .panel_box .navs:hover .nav_title {
        color: #e32322
    }

    .panel_box .navs:hover .each_menu .fa {
        color: white
    }
</style>
